// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import './assets/css/demo.css'
import './assets/css/theme.css'
import './assets/css/dn-common.css'
import './assets/css/dn-common-new.css'
import 'swiper/swiper-bundle.css'
import 'element-ui/lib/theme-chalk/index.css'

import './assets/font/font.css'

Vue.config.productionTip = false
Vue.prototype.bus = new Vue()

var _hmt = _hmt || [];
window._hmt = _hmt;
(function () {
   var hm = document.createElement("script");
   hm.src = "https://hm.baidu.com/hm.js?707bf7759e12e03abe7434eb8dead619";
   var s = document.getElementsByTagName("script")[0];
   s.parentNode.insertBefore(hm, s);
})();

/* eslint-disable no-new */
let startApp = function () {
  axios.get('static/page-config.json').then(res => {
    Vue.prototype.$global = res.data

    new Vue({
      el: '#app',
      router,
      components: { App },
      template: '<App/>',
      data: {
      },
      methods: {
      }
    })
  })
}

startApp()



// WEBPACK FOOTER //
// ./src/main.js